(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/pay-numbergames/assets/javascripts/make-payment.js') >= 0) return;  svs.modules.push('/components/numbergames/pay-numbergames/assets/javascripts/make-payment.js');

'use strict';

const {
  campaign: {
    openCampaignApi,
    asyncOpenCampaignApi
  },
  productMapping
} = svs.numbergames;
const {
  account_services: accountServices,
  api_calls: apiCalls,
  communication,
  dialogs,
  misc,
  utils
} = svs.tur.pay;
const {
  ifIsProlongation,
  verifyActiveAccount,
  updateAccountBalance,
  checkSyndicateTerms,
  updateDraws,
  ifHasClosedJokerDraws,
  closedJokerDrawDialog,
  removeClosedJoker,
  ifDrawOpenIsToday,
  playNextDrawDialog,
  addDataToWagers,
  confirmPaymentTitle,
  confirmPaymentMessages,
  handlePayResponse,
  ifDrawHasClosed,
  ifHasIncompleteWagers,
  trackPayment
} = svs.numbergames.pay_numbergames;
async function numberOfChances(_ref) {
  let {
    next,
    product,
    successfulWagers
  } = _ref;
  await asyncOpenCampaignApi.getCampaign(product);
  const chances = successfulWagers.reduce((chances, _ref2) => {
    var _wager$bets$find, _wager$bets;
    let {
      wager
    } = _ref2;
    const bet = (_wager$bets$find = (_wager$bets = wager.bets).find) === null || _wager$bets$find === void 0 ? void 0 : _wager$bets$find.call(_wager$bets, bet => !productMapping.isJoker(bet.productId));
    return chances + openCampaignApi.calculateChances(product, {
      wager,
      draw: bet
    });
  }, 0);
  return next({
    chances
  });
}
function calculateActualPaidPrice(_ref3) {
  let {
    next,
    successfulWagers,
    successfulTickets
  } = _ref3;
  const wagersPrice = (sum, _ref4) => {
    let {
      wagerAmounts
    } = _ref4;
    return sum + svs.utils.format.CurrencyFromJupiterString(wagerAmounts.betAmount);
  };
  const ticketsPrice = (sum, _ref5) => {
    let {
      price
    } = _ref5;
    return sum + price;
  };
  next({
    actualPaidPrice: successfulWagers.reduce(wagersPrice, 0) + successfulTickets.reduce(ticketsPrice, 0)
  });
}
function removeWageridQuery(_ref6) {
  let {
    next
  } = _ref6;
  svs.utils.paramHandler.remove({
    key: 'wagerid'
  });
  next();
}
async function saveProlongedWagerIdToLocalStorage(_ref7) {
  let {
    wagerId,
    product,
    next
  } = _ref7;
  if (!svs.core.detect.feature('ft-lyckoplatsen-new-prolong')) {
    svs.components.Storage.browser.set(wagerId, 'numbergameProlong', true, svs.components.Storage.constants.EXPIRES_1H);
  }
  await svs.tur.prolongStorage.set({
    wagerId,
    productId: product
  });
  next();
}

function isPayAfterDeposit() {
  const isPayAfterDeposit = svs.utils.paramHandler.get({
    key: 'afterpay'
  }).value;
  svs.utils.paramHandler.remove({
    key: 'afterpay'
  });
  return Boolean(isPayAfterDeposit);
}
function makePayment(_ref8) {
  let {
    onDoneCb,
    onSuccessCb,
    onCancelCallback,
    saveState,
    wagerData,
    ticketData,
    showSuccessDialog = true
  } = _ref8;
  let product;
  let price;
  let drawCount;
  let wagers;
  let isSyndicate;
  let syndicate;
  let accountBalance;
  let draws;
  let regWagerResults;
  let closedWager;
  let incompleteWagers;
  let successfulWagers;
  let failedWagers;
  let grassrootsReceivers;
  let chances;
  let successfulTickets;
  let failedTickets;
  let actualPaidPrice;
  let lastDrawDate;
  let wagerId;
  const isAfterDeposit = isPayAfterDeposit();
  const isAutoPayAfterDeposit = svs.core.detect.feature('ft-numbergames-pay-after-deposit');
  if (wagerData) {
    ({
      product,
      price,
      drawCount,
      wagers,
      lastDrawDate
    } = wagerData);
    if (Array.isArray(ticketData)) {
      ticketData.forEach(ticket => {
        price += ticket.price;
      });
    } else if (ticketData) {
      price += ticketData.price;
    }
  }
  const calls = [{
    in: () => ({
      price,
      product,
      drawCount
    }),
    fn: accountServices.playerSession
  }, {
    fn: accountServices.playerSuspension
  }, {
    fn: accountServices.dayTimeLimit
  }, {
    fn: verifyActiveAccount,
    out: args => ({
      isSyndicate,
      syndicate
    } = args)
  }, {
    in: () => ({
      isSyndicate
    }),
    fn: checkSyndicateTerms
  }, {
    in: () => ({
      price,
      product,
      isSyndicate,
      syndicate,
      isAutoPayAfterDeposit
    }),
    fn: accountServices.accountBalance,
    out: args => ({
      accountBalance
    } = args)
  }, function mainPaymentSequence(isRetry) {
    return {
      calls: [{
        in: () => ({
          wagers
        }),
        fn: updateDraws,
        out: args => ({
          draws
        } = args)
      }, ifHasClosedJokerDraws({
        params: () => ({
          wagers,
          draws
        }),
        calls: _ref9 => {
          let {
            productWithClosedJoker
          } = _ref9;
          return [{
            in: () => ({
              productWithClosedJoker
            }),
            fn: closedJokerDrawDialog
          }, {
            in: () => ({
              wagers,
              price,
              productWithClosedJoker
            }),
            fn: removeClosedJoker,
            out: args => ({
              wagers,
              price
            } = args)
          }];
        }
      }), ifDrawOpenIsToday({
        params: () => ({
          wagers,
          draws,
          lastDrawDate
        }),
        calls: _ref0 => {
          let {
            productOpenedToday,
            regCloseTime
          } = _ref0;
          return [{
            in: () => ({
              product: productOpenedToday,
              regCloseTime,
              isSyndicate
            }),
            fn: playNextDrawDialog
          }];
        }
      }), {
        in: () => ({
          wagers,
          draws,
          isSyndicate,
          syndicate
        }),
        fn: addDataToWagers,
        out: args => ({
          wagers
        } = args)
      }, ...(isRetry || isAutoPayAfterDeposit && !isSyndicate && isAfterDeposit ? [] : [{
        in: () => ({
          accountBalance,
          isSyndicate,
          syndicate,
          price,
          title: confirmPaymentTitle({
            product,
            wagers,
            price,
            isSyndicate,
            ticket: ticketData
          }),
          messages: confirmPaymentMessages(wagers, product),
          product,
          isProlongation: new RegExp(/\/[a-z]+\/forlang-mina-spel\/[0-9]+/).test(window.location.pathname)
        }),
        fn: dialogs.confirmPayment
      }]), {
        in: () => ({
          wagers
        }),
        fn: apiCalls.payWagers,
        out: args => ({
          regWagerResults
        } = args)
      }, {
        in: () => ({
          regWagerResults,
          wagers,
          successfulWagers,
          failedWagers
        }),
        fn: handlePayResponse,
        out: args => ({
          closedWager,
          incompleteWagers,
          successfulWagers,
          failedWagers
        } = args)
      }, ifDrawHasClosed({
        params: () => ({
          closedWager
        }),
        calls: () => [mainPaymentSequence.bind(null, true)]
      })]
    };
  }, function handleIncompleteWagers() {
    return {
      calls: [ifHasIncompleteWagers({
        params: () => ({
          incompleteWagers
        }),
        calls: () => [{
          in: () => ({
            wagers: incompleteWagers
          }),
          fn: apiCalls.payWagers,
          out: args => ({
            regWagerResults
          } = args)
        }, {
          in: () => ({
            regWagerResults,
            wagers,
            successfulWagers,
            failedWagers
          }),
          fn: handlePayResponse,
          out: args => ({
            incompleteWagers,
            successfulWagers,
            failedWagers
          } = args)
        }, handleIncompleteWagers]
      })]
    };
  }, {
    in: () => ({
      ticket: ticketData,
      channel: product
    }),
    fn: apiCalls.payTicket,
    out: args => ({
      successfulTickets,
      failedTickets
    } = args)
  }, {
    in: () => ({
      successfulWagers,
      successfulTickets
    }),
    fn: calculateActualPaidPrice,
    out: args => ({
      actualPaidPrice
    } = args)
  }, {
    in: () => ({
      accountBalance,
      actualPaidPrice,
      syndicate,
      isSyndicate
    }),
    fn: updateAccountBalance
  }, {
    fn: _ref1 => {
      let {
        next
      } = _ref1;
      utils.logPaymentResults({
        successfulTickets,
        failedTickets,
        successfulWagers,
        failedWagers
      });
      onSuccessCb === null || onSuccessCb === void 0 || onSuccessCb({
        successfulWagers
      });
      next();
    }
  }, ifIsProlongation({
    params: () => {
      var _wagerData$prolongedW;
      return {
        wagerId: (_wagerData$prolongedW = wagerData === null || wagerData === void 0 ? void 0 : wagerData.prolongedWagerId) !== null && _wagerData$prolongedW !== void 0 ? _wagerData$prolongedW : wagerId
      };
    },
    calls: () => [{
      in: () => {
        var _wagerData$prolongedW2;
        return {
          wagerId: (_wagerData$prolongedW2 = wagerData === null || wagerData === void 0 ? void 0 : wagerData.prolongedWagerId) !== null && _wagerData$prolongedW2 !== void 0 ? _wagerData$prolongedW2 : wagerId,
          product: wagerData.product
        };
      },
      fn: saveProlongedWagerIdToLocalStorage
    }, {
      fn: removeWageridQuery
    }]
  }), {
    in: () => ({
      product,
      successfulWagers,
      syndicate,
      isSyndicate
    }),
    fn: trackPayment
  }, ...(showSuccessDialog ? [{
    in: () => ({
      isSyndicate
    }),
    fn: misc.getGrassrootsReceivers,
    out: args => ({
      grassrootsReceivers
    } = args)
  }, {
    in: () => ({
      product,
      successfulWagers
    }),
    fn: numberOfChances,
    out: args => ({
      chances
    } = args)
  }, {
    in: () => ({
      product,
      isSyndicate,
      successfulTickets,
      title: dialogs.getSuccessTitle({
        product,
        isSyndicate,
        failedWagers,
        successfulWagers,
        failedTickets
      }),
      messages: dialogs.getSuccessMessages({
        product,
        price: actualPaidPrice,
        isSyndicate,
        syndicate,
        grassrootsReceivers,
        chances,
        failedWagers,
        successfulTickets,
        failedTickets
      })
    }),
    fn: dialogs.paymentSuccess
  }] : []), {
    in: () => ({
      product: productMapping.getProductName(product)
    }),
    fn: communication.correctionEmail
  }, ifIsProlongation({
    params: () => ({
      wagerId
    }),
    calls: () => [{
      fn: svs.tur.pay.misc.showGrassrootsToaster
    }]
  })];
  svs.tur.pay.initPay({
    calls,
    cancel: () => {
      onCancelCallback === null || onCancelCallback === void 0 || onCancelCallback();
    },
    done: () => {
      var _successfulWagers, _failedWagers, _failedTickets;
      const wagerIds = !showSuccessDialog ? (_successfulWagers = successfulWagers) === null || _successfulWagers === void 0 ? void 0 : _successfulWagers.map(_ref10 => {
        let {
          wagerClientSerial
        } = _ref10;
        return wagerClientSerial;
      }) : [];
      let partialPaymentFailed = false;
      if ((_failedWagers = failedWagers) !== null && _failedWagers !== void 0 && _failedWagers.length || (_failedTickets = failedTickets) !== null && _failedTickets !== void 0 && _failedTickets.length) {
        partialPaymentFailed = true;
      }
      onDoneCb === null || onDoneCb === void 0 || onDoneCb({
        price: actualPaidPrice,
        wagerIds,
        successfulTickets,
        partialPaymentFailed
      });
    },
    saveState
  });
}
svs.numbergames.pay_numbergames.makePayment = makePayment;

 })(window);